/**
 * Unit System Toggle Component
 * Allows switching between Imperial and Metric units
 */

import React from 'react'
import { UnitSystem } from '../types/calculator.types'
import styles from './UnitSystemToggle.module.css'

interface UnitSystemToggleProps {
  value: UnitSystem
  onChange: (unitSystem: UnitSystem) => void
  disabled?: boolean
  className?: string
}

const UnitSystemToggle: React.FC<UnitSystemToggleProps> = ({
  value,
  onChange,
  disabled = false,
  className = ''
}) => {
  return (
    <div className={`${styles.toggle} ${className}`}>
      <label className={styles.label}>
        Unit System
      </label>
      <div className={styles.toggleContainer}>
        <button
          type="button"
          className={`btn-toggle ${value === 'imperial' ? styles.active : ''}`}
          onClick={() => onChange('imperial')}
          disabled={disabled}
          aria-pressed={value === 'imperial'}
        >
          <span className={styles.buttonIcon}>📏</span>
          Imperial
          <span className={styles.buttonSubtext}>(sq.ft, in, lb)</span>
        </button>
        <button
          type="button"
          className={`btn-toggle ${value === 'metric' ? styles.active : ''}`}
          onClick={() => onChange('metric')}
          disabled={disabled}
          aria-pressed={value === 'metric'}
        >
          <span className={styles.buttonIcon}>📐</span>
          Metric
          <span className={styles.buttonSubtext}>(sq.m, mm, kg)</span>
        </button>
      </div>
    </div>
  )
}

export default UnitSystemToggle